module.exports = __webpack_public_path__ + "static/media/facebook.8fe81fff.svg";